import { getOrCreatePulse } from '@/tools/tracking/utils';

export const trackLinkClick = (userId: string, pulseEventName: string) => {
  getOrCreatePulse()?.queueEvent({
    type: 'Engagement',
    object: {
      '@type': 'UIElement',
      '@id': `sdrn:subito:classified:${userId}:element:${pulseEventName}`,
    },
  });
};
